import React, { Component } from 'react';

export function SelectCityList(props) {
    return <select defaultValue="0" class="form-select" onChange={props.handleWorkCity}>
            <option key="-1" value="0">선택</option>
            {props.cityList.map((obj, index) => (
                <option selected={Number(props.optionValue) === Number(obj.cityValue)} key={index} value={obj.cityValue}>{obj.cityName}</option>)
            )
        }</select>
}

export function ShowSelectCity(props) {
    return <select disabled defaultValue="0" class="form-select" onChange={props.handleWorkCity}>
            <option key="-1" value="0">선택</option>
            {props.cityList.map((obj, index) => (
                <option selected={Number(props.optionValue) === Number(obj.cityValue)} key={index} value={obj.cityValue}>{obj.cityName}</option>)
            )
        }</select>
}